export default "__VITE_ASSET__CcHbaL7Z__"